module.exports = __webpack_public_path__ + "static/media/ree_dirgha.9da95488.ogg";